export function buildHierarchicalCategoryOptions(categories, { allOption = null } = {}) {
  const list = categories || []
  const options = []

  const appendCategory = (category, prefix = '') => {
    options.push({
      id: category.id,
      name: `${prefix}${category.name}`,
      picture: category.picture ?? null,
    })

    list
      .filter((child) => child.parent_category_id === category.id)
      .sort((a, b) => a.name.localeCompare(b.name))
      .forEach((child) => appendCategory(child, `${prefix}— `))
  }

  list
    .filter((category) => !category.parent_category_id)
    .sort((a, b) => a.name.localeCompare(b.name))
    .forEach((category) => appendCategory(category))

  const listedIds = new Set(options.map((option) => option.id))
  list
    .filter((category) => !listedIds.has(category.id))
    .sort((a, b) => a.name.localeCompare(b.name))
    .forEach((category) => {
      options.push({
        id: category.id,
        name: category.name,
        picture: category.picture ?? null,
      })
    })

  if (allOption) {
    return [{ picture: null, ...allOption }, ...options]
  }

  return options
}
